// "use client"

// import { useState } from "react"
// import { FaEdit, FaTrash, FaUserPlus, FaSearch, FaStar } from "react-icons/fa"
// import Card from "../admincomponents/Card"
// import Table from "../admincomponents/Table"

// const InstructorManagement = () => {
//   const [showAddModal, setShowAddModal] = useState(false)
//   const [showEditModal, setShowEditModal] = useState(false)
//   const [showDeleteModal, setShowDeleteModal] = useState(false)
//   const [currentInstructor, setCurrentInstructor] = useState(null)
//   const [searchTerm, setSearchTerm] = useState("")
//   const [filterStatus, setFilterStatus] = useState("")

//   // Form state for add/edit instructor
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     specialization: "",
//     status: "Active",
//     phone: "",
//     bio: "",
//     rating: 0,
//     courses: 0,
//     students: 0,
//   })

//   // Sample instructor data
//   const instructorsData = [
//     {
//       id: 1,
//       name: "Jane Smith",
//       email: "jane@example.com",
//       specialization: "Web Development",
//       status: "Active",
//       phone: "234-567-8901",
//       bio: "Experienced web developer with 10+ years of experience",
//       rating: 4.8,
//       courses: 12,
//       students: 450,
//     },
//     {
//       id: 2,
//       name: "Charlie Wilson",
//       email: "charlie@example.com",
//       specialization: "Data Science",
//       status: "Active",
//       phone: "567-890-1234",
//       bio: "Data scientist with expertise in machine learning",
//       rating: 4.6,
//       courses: 8,
//       students: 320,
//     },
//     {
//       id: 3,
//       name: "Fiona Clark",
//       email: "fiona@example.com",
//       specialization: "UX/UI Design",
//       status: "Active",
//       phone: "890-123-4567",
//       bio: "Creative designer with a passion for user experience",
//       rating: 4.9,
//       courses: 5,
//       students: 280,
//     },
//     {
//       id: 4,
//       name: "David Lee",
//       email: "david@example.com",
//       specialization: "Mobile Development",
//       status: "Inactive",
//       phone: "901-234-5678",
//       bio: "iOS and Android developer",
//       rating: 4.3,
//       courses: 6,
//       students: 210,
//     },
//     {
//       id: 5,
//       name: "Grace Taylor",
//       email: "grace@example.com",
//       specialization: "Digital Marketing",
//       status: "Pending",
//       phone: "012-345-6789",
//       bio: "Marketing expert with focus on digital strategies",
//       rating: 4.7,
//       courses: 4,
//       students: 190,
//     },
//     {
//       id: 6,
//       name: "Michael Brown",
//       email: "michael@example.com",
//       specialization: "Business Analytics",
//       status: "Active",
//       phone: "123-456-7890",
//       bio: "Business analyst with MBA and industry experience",
//       rating: 4.5,
//       courses: 7,
//       students: 240,
//     },
//   ]

//   // Filter instructors based on search term and filters
//   const filteredInstructors = instructorsData.filter((instructor) => {
//     const matchesSearch =
//       instructor.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       instructor.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       instructor.specialization.toLowerCase().includes(searchTerm.toLowerCase())
//     const matchesStatus = filterStatus === "" || instructor.status === filterStatus

//     return matchesSearch && matchesStatus
//   })

//   // Table columns configuration
//   const columns = [
//     { key: "name", label: "Name", sortable: true },
//     { key: "email", label: "Email", sortable: true },
//     { key: "specialization", label: "Specialization", sortable: true },
//     {
//       key: "rating",
//       label: "Rating",
//       sortable: true,
//       render: (row) => (
//         <div style={{ display: "flex", alignItems: "center" }}>
//           <span style={{ marginRight: "5px" }}>{row.rating}</span>
//           <FaStar style={{ color: "#ffc107" }} />
//         </div>
//       ),
//     },
//     { key: "courses", label: "Courses", sortable: true },
//     { key: "students", label: "Students", sortable: true },
//     {
//       key: "status",
//       label: "Status",
//       sortable: true,
//       render: (row) => (
//         <span
//           style={{
//             padding: "3px 8px",
//             borderRadius: "12px",
//             fontSize: "12px",
//             backgroundColor: row.status === "Active" ? "#e6f7e6" : row.status === "Pending" ? "#fff8e6" : "#ffe6e6",
//             color: row.status === "Active" ? "#4caf50" : row.status === "Pending" ? "#ff9800" : "#f44336",
//           }}
//         >
//           {row.status}
//         </span>
//       ),
//     },
//     {
//       key: "actions",
//       label: "Actions",
//       sortable: false,
//       render: (row) => (
//         <div style={{ display: "flex", gap: "10px" }}>
//           <button
//             onClick={() => handleEditClick(row)}
//             style={{
//               background: "none",
//               border: "none",
//               color: "#7366ff",
//               cursor: "pointer",
//               fontSize: "16px",
//             }}
//           >
//             <FaEdit />
//           </button>
//           <button
//             onClick={() => handleDeleteClick(row)}
//             style={{
//               background: "none",
//               border: "none",
//               color: "#ff5370",
//               cursor: "pointer",
//               fontSize: "16px",
//             }}
//           >
//             <FaTrash />
//           </button>
//         </div>
//       ),
//     },
//   ]

//   // Handle form input changes
//   const handleInputChange = (e) => {
//     const { name, value } = e.target
//     setFormData({
//       ...formData,
//       [name]: value,
//     })
//   }

//   // Handle edit instructor click
//   const handleEditClick = (instructor) => {
//     setCurrentInstructor(instructor)
//     setFormData({
//       name: instructor.name,
//       email: instructor.email,
//       specialization: instructor.specialization,
//       status: instructor.status,
//       phone: instructor.phone,
//       bio: instructor.bio,
//       rating: instructor.rating,
//       courses: instructor.courses,
//       students: instructor.students,
//     })
//     setShowEditModal(true)
//   }

//   // Handle delete instructor click
//   const handleDeleteClick = (instructor) => {
//     setCurrentInstructor(instructor)
//     setShowDeleteModal(true)
//   }

//   // Handle add instructor form submit
//   const handleAddSubmit = (e) => {
//     e.preventDefault()
//     // Add instructor logic would go here
//     console.log("Adding instructor:", formData)
//     setShowAddModal(false)
//     // Reset form
//     setFormData({
//       name: "",
//       email: "",
//       specialization: "",
//       status: "Active",
//       phone: "",
//       bio: "",
//       rating: 0,
//       courses: 0,
//       students: 0,
//     })
//   }

//   // Handle edit instructor form submit
//   const handleEditSubmit = (e) => {
//     e.preventDefault()
//     // Edit instructor logic would go here
//     console.log("Editing instructor:", currentInstructor.id, formData)
//     setShowEditModal(false)
//   }

//   // Handle delete instructor confirmation
//   const handleDeleteConfirm = () => {
//     // Delete instructor logic would go here
//     console.log("Deleting instructor:", currentInstructor.id)
//     setShowDeleteModal(false)
//   }

//   // Modal backdrop style
//   const modalBackdropStyle = {
//     position: "fixed",
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     backgroundColor: "rgba(0, 0, 0, 0.5)",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     zIndex: 1000,
//   }

//   // Modal content style
//   const modalContentStyle = {
//     backgroundColor: "white",
//     borderRadius: "10px",
//     padding: "20px",
//     width: "500px",
//     maxWidth: "90%",
//     maxHeight: "90vh",
//     overflowY: "auto",
//   }

//   return (
//     <div>
//       <h1 style={{ marginBottom: "20px", color: "#333" }}>Instructor Management</h1>

//       <Card>
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             flexWrap: "wrap",
//             gap: "15px",
//             marginBottom: "20px",
//           }}
//         >
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               position: "relative",
//               width: "300px",
//             }}
//           >
//             <FaSearch
//               style={{
//                 position: "absolute",
//                 left: "10px",
//                 color: "#888",
//               }}
//             />
//             <input
//               type="text"
//               placeholder="Search instructors..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               style={{
//                 padding: "8px 10px 8px 35px",
//                 border: "1px solid #ddd",
//                 borderRadius: "5px",
//                 width: "100%",
//               }}
//             />
//           </div>

//           <div
//             style={{
//               display: "flex",
//               gap: "10px",
//               flexWrap: "wrap",
//             }}
//           >
//             <div>
//               <select
//                 value={filterStatus}
//                 onChange={(e) => setFilterStatus(e.target.value)}
//                 style={{
//                   padding: "8px 10px",
//                   border: "1px solid #ddd",
//                   borderRadius: "5px",
//                 }}
//               >
//                 <option value="">All Status</option>
//                 <option value="Active">Active</option>
//                 <option value="Inactive">Inactive</option>
//                 <option value="Pending">Pending</option>
//               </select>
//             </div>

//             <button
//               onClick={() => setShowAddModal(true)}
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: "5px",
//                 padding: "8px 15px",
//                 background: "linear-gradient(135deg, #ff5baf, #7366ff)",
//                 color: "white",
//                 border: "none",
//                 borderRadius: "5px",
//                 cursor: "pointer",
//               }}
//             >
//               <FaUserPlus />
//               Add Instructor
//             </button>
//           </div>
//         </div>

//         <Table columns={columns} data={filteredInstructors} pagination={true} itemsPerPage={5} />
//       </Card>

//       {/* Add Instructor Modal */}
//       {showAddModal && (
//         <div style={modalBackdropStyle}>
//           <div style={modalContentStyle}>
//             <h2 style={{ marginBottom: "20px" }}>Add New Instructor</h2>
//             <form onSubmit={handleAddSubmit}>
//               <div style={{ marginBottom: "15px" }}>
//                 <label style={{ display: "block", marginBottom: "5px" }}>Name</label>
//                 <input
//                   type="text"
//                   name="name"
//                   value={formData.name}
//                   onChange={handleInputChange}
//                   required
//                   style={{
//                     width: "100%",
//                     padding: "8px 10px",
//                     border: "1px solid #ddd",
//                     borderRadius: "5px",
//                   }}
//                 />
//               </div>

//               <div style={{ marginBottom: "15px" }}>
//                 <label style={{ display: "block", marginBottom: "5px" }}>Email</label>
//                 <input
//                   type="email"
//                   name="email"
//                   value={formData.email}
//                   onChange={handleInputChange}
//                   required
//                   style={{
//                     width: "100%",
//                     padding: "8px 10px",
//                     border: "1px solid #ddd",
//                     borderRadius: "5px",
//                   }}
//                 />
//               </div>

//               <div style={{ marginBottom: "15px" }}>
//                 <label style={{ display: "block", marginBottom: "5px" }}>Specialization</label>
//                 <input
//                   type="text"
//                   name="specialization"
//                   value={formData.specialization}
//                   onChange={handleInputChange}
//                   required
//                   style={{
//                     width: "100%",
//                     padding: "8px 10px",
//                     border: "1px solid #ddd",
//                     borderRadius: "5px",
//                   }}
//                 />
//               </div>

//               <div style={{ marginBottom: "15px" }}>
//                 <label style={{ display: "block", marginBottom: "5px" }}>Status</label>
//                 <select
//                   name="status"
//                   value={formData.status}
//                   onChange={handleInputChange}
//                   style={{
//                     width: "100%",
//                     padding: "8px 10px",
//                     border: "1px solid #ddd",
//                     borderRadius: "5px",
//                   }}
//                 >
//                   <option value="Active">Active</option>
//                   <option value="Inactive">Inactive</option>
//                   <option value="Pending">Pending</option>
//                 </select>
//               </div>

//               <div style={{ marginBottom: "15px" }}>
//                 <label style={{ display: "block", marginBottom: "5px" }}>Phone</label>
//                 <input
//                   type="text"
//                   name="phone"
//                   value={formData.phone}
//                   onChange={handleInputChange}
//                   style={{
//                     width: "100%",
//                     padding: "8px 10px",
//                     border: "1px solid #ddd",
//                     borderRadius: "5px",
//                   }}
//                 />
//               </div>

//               <div style={{ marginBottom: "20px" }}>
//                 <label style={{ display: "block", marginBottom: "5px" }}>Bio</label>
//                 <textarea
//                   name="bio"
//                   value={formData.bio}
//                   onChange={handleInputChange}
//                   style={{
//                     width: "100%",
//                     padding: "8px 10px",
//                     border: "1px solid #ddd",
//                     borderRadius: "5px",
//                     minHeight: "80px",
//                   }}
//                 />
//               </div>

//               <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
//                 <button
//                   type="button"
//                   onClick={() => setShowAddModal(false)}
//                   style={{
//                     padding: "8px 15px",
//                     background: "#f5f5f5",
//                     border: "1px solid #ddd",
//                     borderRadius: "5px",
//                     cursor: "pointer",
//                   }}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="submit"
//                   style={{
//                     padding: "8px 15px",
//                     background: "linear-gradient(135deg, #ff5baf, #7366ff)",
//                     color: "white",
//                     border: "none",
//                     borderRadius: "5px",
//                     cursor: "pointer",
//                   }}
//                 >
//                   Add Instructor
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}

//       {/* Edit Instructor Modal */}
//       {showEditModal && (
//         <div style={modalBackdropStyle}>
//           <div style={modalContentStyle}>
//             <h2 style={{ marginBottom: "20px" }}>Edit Instructor</h2>
//             <form onSubmit={handleEditSubmit}>
//               <div style={{ marginBottom: "15px" }}>
//                 <label style={{ display: "block", marginBottom: "5px" }}>Name</label>
//                 <input
//                   type="text"
//                   name="name"
//                   value={formData.name}
//                   onChange={handleInputChange}
//                   required
//                   style={{
//                     width: "100%",
//                     padding: "8px 10px",
//                     border: "1px solid #ddd",
//                     borderRadius: "5px",
//                   }}
//                 />
//               </div>

//               <div style={{ marginBottom: "15px" }}>
//                 <label style={{ display: "block", marginBottom: "5px" }}>Email</label>
//                 <input
//                   type="email"
//                   name="email"
//                   value={formData.email}
//                   onChange={handleInputChange}
//                   required
//                   style={{
//                     width: "100%",
//                     padding: "8px 10px",
//                     border: "1px solid #ddd",
//                     borderRadius: "5px",
//                   }}
//                 />
//               </div>

//               <div style={{ marginBottom: "15px" }}>
//                 <label style={{ display: "block", marginBottom: "5px" }}>Specialization</label>
//                 <input
//                   type="text"
//                   name="specialization"
//                   value={formData.specialization}
//                   onChange={handleInputChange}
//                   required
//                   style={{
//                     width: "100%",
//                     padding: "8px 10px",
//                     border: "1px solid #ddd",
//                     borderRadius: "5px",
//                   }}
//                 />
//               </div>

//               <div style={{ marginBottom: "15px" }}>
//                 <label style={{ display: "block", marginBottom: "5px" }}>Status</label>
//                 <select
//                   name="status"
//                   value={formData.status}
//                   onChange={handleInputChange}
//                   style={{
//                     width: "100%",
//                     padding: "8px 10px",
//                     border: "1px solid #ddd",
//                     borderRadius: "5px",
//                   }}
//                 >
//                   <option value="Active">Active</option>
//                   <option value="Inactive">Inactive</option>
//                   <option value="Pending">Pending</option>
//                 </select>
//               </div>

//               <div style={{ marginBottom: "15px" }}>
//                 <label style={{ display: "block", marginBottom: "5px" }}>Phone</label>
//                 <input
//                   type="text"
//                   name="phone"
//                   value={formData.phone}
//                   onChange={handleInputChange}
//                   style={{
//                     width: "100%",
//                     padding: "8px 10px",
//                     border: "1px solid #ddd",
//                     borderRadius: "5px",
//                   }}
//                 />
//               </div>

//               <div style={{ marginBottom: "20px" }}>
//                 <label style={{ display: "block", marginBottom: "5px" }}>Bio</label>
//                 <textarea
//                   name="bio"
//                   value={formData.bio}
//                   onChange={handleInputChange}
//                   style={{
//                     width: "100%",
//                     padding: "8px 10px",
//                     border: "1px solid #ddd",
//                     borderRadius: "5px",
//                     minHeight: "80px",
//                   }}
//                 />
//               </div>

//               <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
//                 <button
//                   type="button"
//                   onClick={() => setShowEditModal(false)}
//                   style={{
//                     padding: "8px 15px",
//                     background: "#f5f5f5",
//                     border: "1px solid #ddd",
//                     borderRadius: "5px",
//                     cursor: "pointer",
//                   }}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="submit"
//                   style={{
//                     padding: "8px 15px",
//                     background: "linear-gradient(135deg, #ff5baf, #7366ff)",
//                     color: "white",
//                     border: "none",
//                     borderRadius: "5px",
//                     cursor: "pointer",
//                   }}
//                 >
//                   Save Changes
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}

//       {/* Delete Instructor Modal */}
//       {showDeleteModal && (
//         <div style={modalBackdropStyle}>
//           <div style={{ ...modalContentStyle, width: "400px" }}>
//             <h2 style={{ marginBottom: "20px" }}>Confirm Delete</h2>
//             <p style={{ marginBottom: "20px" }}>
//               Are you sure you want to delete the instructor <strong>{currentInstructor?.name}</strong>? This action
//               cannot be undone.
//             </p>
//             <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
//               <button
//                 onClick={() => setShowDeleteModal(false)}
//                 style={{
//                   padding: "8px 15px",
//                   background: "#f5f5f5",
//                   border: "1px solid #ddd",
//                   borderRadius: "5px",
//                   cursor: "pointer",
//                 }}
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={handleDeleteConfirm}
//                 style={{
//                   padding: "8px 15px",
//                   background: "#ff5370",
//                   color: "white",
//                   border: "none",
//                   borderRadius: "5px",
//                   cursor: "pointer",
//                 }}
//               >
//                 Delete
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   )
// }

// export default InstructorManagement
import { useEffect, useState } from 'react'
import { FaEdit, FaTrash, FaUserPlus, FaSearch, FaStar } from 'react-icons/fa'
import Card from '../admincomponents/Card'
import Table from '../admincomponents/Table'
import axios from 'axios'
import Swal from 'sweetalert2'

const InstructorManagement = () => {
  const [showAddModal, setShowAddModal] = useState(false)
  const [showEditModal, setShowEditModal] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [currentInstructor, setCurrentInstructor] = useState(null)
  const [searchTerm, setSearchTerm] = useState('')
  const [filterStatus, setFilterStatus] = useState('')
  const [instructors, setInstructors] = useState([])
  const [loading, setLoading] = useState(true)
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    mobile_number: '',
    password: '',
    role_id: 3,
  })
  const token = localStorage.getItem('jwttoken')

  const fetchInstructors = () => {
    setLoading(true)
    axios
      .get('https://kaasbackend.vetrinahealthcare.com/lms/all-users/', {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        const instructorUsers = res.data.users.filter(
          (user) => user.role_id === 3
        )
        setInstructors(instructorUsers)
      })
      .catch((err) => {
        console.error(err)
        Swal.fire('Error', 'Failed to fetch instructors', 'error')
      })
      .finally(() => setLoading(false))
  }
  useEffect(() => {
    fetchInstructors()
  }, [])

  // Filter users based on search term and filters
  const filteredInstructors = instructors.filter((inst) => {
    const matchesSearch =
      inst.first_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      inst.email?.toLowerCase().includes(searchTerm.toLowerCase())
    const matchesStatus = !filterStatus || inst.status === filterStatus
    return matchesSearch && matchesStatus
  })

  // Table columns configuration
  const columns = [
    {
      key: 'name',
      label: 'Name',
      sortable: true,
      render: (row) => `${row.first_name || ''} ${row.last_name || ''}`,
    },
    { key: 'email', label: 'Email', sortable: true },
    {
      key: 'actions',
      label: 'Actions',
      sortable: false,
      render: (row) => (
        <div style={{ display: 'flex', gap: '10px' }}>
          <button
            onClick={() => handleEditClick(row)}
            style={{
              background: 'none',
              border: 'none',
              color: '#7366ff',
              cursor: 'pointer',
              fontSize: '16px',
            }}
          >
            <FaEdit />
          </button>
          <button
            onClick={() => handleDeleteClick(row)}
            style={{
              background: 'none',
              border: 'none',
              color: '#ff5370',
              cursor: 'pointer',
              fontSize: '16px',
            }}
          >
            <FaTrash />
          </button>
        </div>
      ),
    },
  ]

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData({
      ...formData,
      [name]: value,
    })
  }

  // Handle edit instructor click
  const handleEditClick = (instructor) => {
    setCurrentInstructor(instructor)
    setFormData({
      first_name: instructor.first_name || '',
      last_name: instructor.last_name || '',
      email: instructor.email || '',
      mobile_number: instructor.mobile_number || '',
      password: '', // usually kept empty
    })
    setShowEditModal(true)
  }

  // Handle delete instructor click
  const handleDeleteClick = (instructor) => {
    setCurrentInstructor(instructor)
    setShowDeleteModal(true)
  }

  // Handle add instructor form submit
  const handleAddSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    try {
      await axios.post(
        'https://kaasbackend.vetrinahealthcare.com/auth/admin/create-user/',
        { ...formData, role_id: 3 },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      Swal.fire('Success', 'Instructor added successfully!', 'success')
      setShowAddModal(false)
      setFormData({
        email: '',
        password: '',
        first_name: '',
        last_name: '',
        mobile_number: '',
        role_id: 3,
      })
      fetchInstructors()
    } catch (error) {
      console.error(error)
      Swal.fire('Error', 'Failed to add instructor', 'error')
    } finally {
      setLoading(false)
    }
  }

  const handleEditSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    try {
      await axios.patch(
        `https://kaasbackend.vetrinahealthcare.com/lms/users-update/${currentInstructor.user_id}/`,
        formData,
        { headers: { Authorization: `Bearer ${token}` } }
      )
      Swal.fire('Success', 'Instructor updated successfully!', 'success')
      setShowEditModal(false)
      fetchInstructors()
    } catch (err) {
      console.error(err)
      Swal.fire('Error', 'Failed to update instructor', 'error')
    } finally {
      setLoading(false)
    }
  }

  const handleDeleteConfirm = async () => {
    setLoading(true)
    try {
      await axios.delete(
        `https://kaasbackend.vetrinahealthcare.com/lms/users-delete/${currentInstructor.user_id}/`,
        { headers: { Authorization: `Bearer ${token}` } }
      )
      Swal.fire('Deleted!', 'Instructor has been deleted.', 'success')
      setShowDeleteModal(false)
      fetchInstructors()
    } catch (err) {
      console.error(err)
      Swal.fire('Error', 'Failed to delete instructor', 'error')
    } finally {
      setLoading(false)
    }
  }

  // Modal backdrop style
  const modalBackdropStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
  }

  // Modal content style
  const modalContentStyle = {
    backgroundColor: 'white',
    borderRadius: '10px',
    padding: '20px',
    width: '500px',
    maxWidth: '90%',
    maxHeight: '90vh',
    overflowY: 'auto',
  }

  return (
    <div>
      <h1 style={{ marginBottom: '20px', color: '#333' }}>
        Instructor Management
      </h1>

      <Card>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: '15px',
            marginBottom: '20px',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              position: 'relative',
              width: '300px',
            }}
          >
            <FaSearch
              style={{
                position: 'absolute',
                left: '10px',
                color: '#888',
              }}
            />
            <input
              type='text'
              placeholder='Search instructors...'
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{
                padding: '8px 10px 8px 35px',
                border: '1px solid #ddd',
                borderRadius: '5px',
                width: '100%',
              }}
            />
          </div>

          <div
            style={{
              display: 'flex',
              gap: '10px',
              flexWrap: 'wrap',
            }}
          >
            {/* <div>
              <select
                value={filterStatus}
                onChange={(e) => setFilterStatus(e.target.value)}
                style={{
                  padding: '8px 10px',
                  border: '1px solid #ddd',
                  borderRadius: '5px',
                }}
              >
                <option value=''>All Status</option>
                <option value='Active'>Active</option>
                <option value='Inactive'>Inactive</option>
                <option value='Pending'>Pending</option>
              </select>
            </div> */}

            <button
              onClick={() => setShowAddModal(true)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '5px',
                padding: '8px 15px',
                background: 'linear-gradient(135deg, #ff5baf, #7366ff)',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
              }}
            >
              <FaUserPlus />
              Add Instructor
            </button>
          </div>
        </div>

        {loading ? (
          <div style={{ textAlign: 'center', padding: '20px' }}>
            <div className='spinner-border text-primary' role='status'>
              <span className='visually-hidden'>Loading...</span>
            </div>
          </div>
        ) : (
          <Table
            columns={columns}
            data={filteredInstructors}
            pagination={true}
            itemsPerPage={5}
          />
        )}
      </Card>

      {/* Add Instructor Modal */}
      {showAddModal && (
        <div style={modalBackdropStyle}>
          <div style={modalContentStyle}>
            <h2 style={{ marginBottom: '20px' }}>Add New Instructor</h2>
            <form onSubmit={handleAddSubmit}>
              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '5px' }}>
                  First Name
                </label>
                <input
                  type='text'
                  name='first_name'
                  value={formData.first_name}
                  onChange={handleInputChange}
                  required
                  style={{
                    width: '100%',
                    padding: '8px 10px',
                    border: '1px solid #ddd',
                    borderRadius: '5px',
                  }}
                />
              </div>

              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '5px' }}>
                  Last Name
                </label>
                <input
                  type='text'
                  name='last_name'
                  value={formData.last_name}
                  onChange={handleInputChange}
                  required
                  style={{
                    width: '100%',
                    padding: '8px 10px',
                    border: '1px solid #ddd',
                    borderRadius: '5px',
                  }}
                />
              </div>
              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '5px' }}>
                  Email
                </label>
                <input
                  type='email'
                  name='email'
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  style={{
                    width: '100%',
                    padding: '8px 10px',
                    border: '1px solid #ddd',
                    borderRadius: '5px',
                  }}
                />
              </div>

              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '5px' }}>
                  Mobile Number
                </label>
                <input
                  type='text'
                  name='mobile_number'
                  value={formData.mobile_number}
                  onChange={handleInputChange}
                  required
                  style={{
                    width: '100%',
                    padding: '8px 10px',
                    border: '1px solid #ddd',
                    borderRadius: '5px',
                  }}
                />
              </div>

              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '5px' }}>
                  Password
                </label>
                <input
                  type='password'
                  name='password'
                  value={formData.password}
                  onChange={handleInputChange}
                  required
                  style={{
                    width: '100%',
                    padding: '8px 10px',
                    border: '1px solid #ddd',
                    borderRadius: '5px',
                  }}
                />
              </div>

              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  gap: '10px',
                }}
              >
                <button
                  type='button'
                  onClick={() => setShowAddModal(false)}
                  style={{
                    padding: '8px 15px',
                    background: '#f5f5f5',
                    border: '1px solid #ddd',
                    borderRadius: '5px',
                    cursor: 'pointer',
                  }}
                >
                  Cancel
                </button>
                <button
                  type='submit'
                  style={{
                    padding: '8px 15px',
                    background: 'linear-gradient(135deg, #ff5baf, #7366ff)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                  }}
                >
                  Add Instructor
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Edit Instructor Modal */}
      {showEditModal && (
        <div style={modalBackdropStyle}>
          <div style={modalContentStyle}>
            <h2 style={{ marginBottom: '20px' }}>Edit Instructor</h2>
            <form onSubmit={handleEditSubmit}>
              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '5px' }}>
                  First Name
                </label>
                <input
                  type='text'
                  name='first_name'
                  value={formData.first_name}
                  onChange={handleInputChange}
                  required
                  style={{
                    width: '100%',
                    padding: '8px 10px',
                    border: '1px solid #ddd',
                    borderRadius: '5px',
                  }}
                />
              </div>
              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '5px' }}>
                  Last Name
                </label>
                <input
                  type='text'
                  name='last_name'
                  value={formData.last_name}
                  onChange={handleInputChange}
                  required
                  style={{
                    width: '100%',
                    padding: '8px 10px',
                    border: '1px solid #ddd',
                    borderRadius: '5px',
                  }}
                />
              </div>

              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '5px' }}>
                  Email
                </label>
                <input
                  type='email'
                  name='email'
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  style={{
                    width: '100%',
                    padding: '8px 10px',
                    border: '1px solid #ddd',
                    borderRadius: '5px',
                  }}
                />
              </div>

              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '5px' }}>
                  Phone
                </label>
                <input
                  type='text'
                  name='phone'
                  value={formData.phone}
                  onChange={handleInputChange}
                  style={{
                    width: '100%',
                    padding: '8px 10px',
                    border: '1px solid #ddd',
                    borderRadius: '5px',
                  }}
                />
              </div>

              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '5px' }}>
                  Password
                </label>
                <input
                  type='text'
                  name='password'
                  value={formData.password}
                  onChange={handleInputChange}
                  required
                  style={{
                    width: '100%',
                    padding: '8px 10px',
                    border: '1px solid #ddd',
                    borderRadius: '5px',
                  }}
                />
              </div>

              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  gap: '10px',
                }}
              >
                <button
                  type='button'
                  onClick={() => setShowEditModal(false)}
                  style={{
                    padding: '8px 15px',
                    background: '#f5f5f5',
                    border: '1px solid #ddd',
                    borderRadius: '5px',
                    cursor: 'pointer',
                  }}
                >
                  Cancel
                </button>
                <button
                  type='submit'
                  style={{
                    padding: '8px 15px',
                    background: 'linear-gradient(135deg, #ff5baf, #7366ff)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                  }}
                >
                  Save Changes
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Delete Instructor Modal */}
      {showDeleteModal && (
        <div style={modalBackdropStyle}>
          <div style={{ ...modalContentStyle, width: '400px' }}>
            <h2 style={{ marginBottom: '20px' }}>Confirm Delete</h2>
            <p style={{ marginBottom: '20px' }}>
              Are you sure you want to delete the instructor{' '}
              <strong>{currentInstructor?.name}</strong>? This action cannot be
              undone.
            </p>
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                gap: '10px',
              }}
            >
              <button
                onClick={() => setShowDeleteModal(false)}
                style={{
                  padding: '8px 15px',
                  background: '#f5f5f5',
                  border: '1px solid #ddd',
                  borderRadius: '5px',
                  cursor: 'pointer',
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleDeleteConfirm}
                style={{
                  padding: '8px 15px',
                  background: '#ff5370',
                  color: 'white',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                }}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default InstructorManagement